import { render, staticRenderFns } from "./whatsapp-reports.vue?vue&type=template&id=07ccc816&scoped=true"
import script from "./whatsapp-reports.vue?vue&type=script&lang=js"
export * from "./whatsapp-reports.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-reports.vue?vue&type=style&index=0&id=07ccc816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ccc816",
  null
  
)

export default component.exports